import { axInstBasic } from "../../components/Service/Service";

// Utility function to prepare payload
export const getArnPayload = (parArn, childArn) => {
  if (childArn) {
    return { childArn };
  } else if (parArn) {
    return { parArn };
  } else {
    throw new Error("No ARN provided for fuel efficiency API.");
  }
};

// Fetch function for fuel efficiency cluster Q1
export const fetchFuelEfficiency = async (parArn, childArn) => {
  // console.log("ParArn & ChildArn", parArn, childArn)
  const payload = getArnPayload(parArn, childArn);

  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}fuelEfficiency-cluster`,
      payload
    );
    // console.log("API response (fetchFuelEfficiencyQ1):", res.data);
    return res.data;
  } catch (error) {
    console.error("Error fetching fuel efficiency data:", error);
    throw error;
  }
};

export const fetchFuelEfficiencyQ2 = async (parArn, childArn) => {
  // console.log("ParArn & ChildArn", parArn, childArn)
  const payload = getArnPayload(parArn, childArn);

  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}fuelEfficiency_clusterQ2`,
      payload
    );
    // console.log("API response (fetchFuelEfficiencyQ1):", res.data);
    return res.data;
  } catch (error) {
    console.error("Error fetching fuel efficiency data:", error);
    throw error;
  }
};

export const fetchFuelEfficiencyQ3 = async (parArn, childArn) => {
  // console.log("ParArn & ChildArn", parArn, childArn)
  const payload = getArnPayload(parArn, childArn);

  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}fuelEfficiency_clusterQ3`,
      payload
    );
    // console.log("API response (fetchFuelEfficiencyQ1):", res.data);
    return res.data;
  } catch (error) {
    console.error("Error fetching fuel efficiency data:", error);
    throw error;
  }
};

export const fetchFuelEfficiencyQ4 = async (parArn, childArn) => {
  // console.log("ParArn & ChildArn", parArn, childArn)
  const payload = getArnPayload(parArn, childArn);

  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}FuelEfficiency_clusterQ4`,
      payload
    );
    // console.log("API response (fetchFuelEfficiencyQ1):", res.data);
    return res.data;
  } catch (error) {
    console.error("Error fetching fuel efficiency data:", error);
    throw error;
  }
};

export const fetchsubcriptionsaledetail = async (parArn, childArn) => {
  // console.log("ParArn & ChildArn", parArn, childArn)
  const payload = getArnPayload(parArn, childArn);

  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}subcription-sale-detail`,
      payload
    );
    // console.log("API response (fetchFuelEfficiencyQ1):", res.data);
    return res.data;
  } catch (error) {
    console.error("Error fetching fuel efficiency data:", error);
    throw error;
  }
};

export const fetchsubcriptionsalecount = async (parArn, childArn) => {
  // console.log("ParArn & ChildArn", parArn, childArn)
  const payload = getArnPayload(parArn, childArn);

  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}subcription-sale-count`,
      payload
    );
    // console.log("API response (fetchFuelEfficiencyQ1):", res.data);
    return res.data;
  } catch (error) {
    console.error("Error fetching fuel efficiency data:", error);
    throw error;
  }
};

export const fetchflatfleetdistribution = async (parArn, childArn) => {
  // console.log("ParArn & ChildArn", parArn, childArn)
  const payload = getArnPayload(parArn, childArn);

  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}flat-fleet-distribution`,
      payload
    );
    // console.log("API response (fetchFuelEfficiencyQ1):", res.data);
    return res.data;
  } catch (error) {
    console.error("Error fetching fuel efficiency data:", error);
    throw error;
  }
};

export const fetchavgkmrunperday = async (
  parArn,
  childArn,
  fleetedgePayload
) => {
  // console.log("ParArn & ChildArn", parArn, childArn);
  const payload = getArnPayload(parArn, childArn);
  const values = {
    ...payload,
    ...fleetedgePayload,
  };

  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}avg-km-run-per-day`,
      values
    );
    // console.log("API response (fetchFuelEfficiencyQ1):", res.data);
    return res.data;
  } catch (error) {
    console.error("Error fetching fuel efficiency data:", error);
    throw error;
  }
};

export const fetchlast30Days = async (parArn, childArn, fleetedgePayload) => {
  // console.log("ParArn & ChildArn", parArn, childArn)
  const payload = getArnPayload(parArn, childArn);
  const values = {
    ...payload,
    ...fleetedgePayload,
  };
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}last-30-Days`,
      values
    );
    // console.log("API response (fetchFuelEfficiencyQ1):", res.data);
    return res.data;
  } catch (error) {
    console.error("Error fetching fuel efficiency data:", error);
    throw error;
  }
};

export const fetchtdtfleet = async (parArn, childArn, fleetedgePayload) => {
  // console.log("ParArn & ChildArn", parArn, childArn)
  const payload = getArnPayload(parArn, childArn);
  const values = {
    ...payload,
    ...fleetedgePayload,
  };
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}tdt-fleet`,
      values
    );
    // console.log("API response (fetchFuelEfficiencyQ1):", res.data);
    return res.data;
  } catch (error) {
    console.error("Error fetching fuel efficiency data:", error);
    throw error;
  }
};

export const fetchtotalrunhours = async (
  parArn,
  childArn,
  fleetedgePayload
) => {
  // console.log("ParArn & ChildArn", parArn, childArn);
  const payload = getArnPayload(parArn, childArn);
  const values = {
    ...payload,
    ...fleetedgePayload,
  };
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}total-run-hours`,
      values
    );
    // console.log("API response (fetchFuelEfficiencyQ1):", res.data);
    return res.data;
  } catch (error) {
    console.error("Error fetching fuel efficiency data:", error);
    throw error;
  }
};

export const fetchtcvfleet = async (parArn, childArn, fleetedgePayload) => {
  // console.log("ParArn & ChildArn", parArn, childArn)
  const payload = getArnPayload(parArn, childArn);
  const values = {
    ...payload,
    ...fleetedgePayload,
  };

  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}tcv-fleet`,

      values
    );
    // console.log("API response (fetchFuelEfficiencyQ1):", res.data);
    return res.data;
  } catch (error) {
    console.error("Error fetching fuel efficiency data:", error);
    throw error;
  }
};

export const plFilterValues = async (parArn, childArn) => {
  const payload = getArnPayload(parArn, childArn);

  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}pl-filter-values`,
      payload
    );
    return res.data;
  } catch (error) {
    console.error("Error fetching pl-filter-values data:", error);
    throw error;
  }
};
